export default "__VITE_ASSET__DLw2iAUA__"